import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const containerStyles = (disabled?: boolean): SxProps<Theme> => ({
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 1,
  width: 60,
  height: 61,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  cursor: disabled ? 'not-allowed' : 'grab',
  transition: 'all 0.2s ease-in-out',
  '.step-handle path': {
    fill: (theme) => (disabled ? theme.palette.grey[400] : theme.palette.text.secondary),
    transition: 'fill 0.2s ease-in-out',
  },
  '.step-content path': {
    fill: (theme) => (disabled ? theme.palette.grey[300] : theme.palette.grey[400]),
    transition: 'fill 0.2s ease-in-out',
  },
  '&:hover': {
    backgroundColor: (theme) => (!disabled ? alpha(theme.palette.primary.main, 0.04) : 'inherit'),
    '.step-content-wrapper': {
      border: (theme) => (!disabled ? `1px solid ${theme.palette.primary.main}` : 'inherit'),
    },
    '.step-handle path': {
      fill: (theme) => (!disabled ? theme.palette.primary.main : theme.palette.grey[400]),
    },
    '.step-content path': {
      fill: (theme) => (!disabled ? alpha(theme.palette.primary.main, 0.5) : theme.palette.grey[300]),
    },
  },
  '&:active': {
    backgroundColor: (theme) => (!disabled ? alpha(theme.palette.primary.main, 0.08) : 'inherit'),
    transform: !disabled ? 'scale(0.98)' : 'none',
    '.step-content-wrapper': {
      border: (theme) => (!disabled ? `1px solid ${theme.palette.primary.main}` : 'inherit'),
    },
  },
});

export const contentWrapperStyles = (disabled?: boolean): SxProps<Theme> => ({
  border: (theme) => `1px solid ${disabled ? theme.palette.divider : theme.palette.text.secondary}`,
  alignItems: 'center',
  backgroundColor: (theme) => theme.palette.common.white,
  boxSizing: 'border-box',
  borderRadius: 0.5,
  display: 'flex',
  height: 24,
  justifyContent: 'center',
  mx: '2px',
  width: 32,
});

export const spacerStyles = {
  width: 10,
};

export const rotatedArrowStyles = {
  transform: 'rotate(180deg)',
};
